// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { formatNumber } from "@sequentech/ui-core";
import { getPieChartNumberFormatOptions } from "./chartNumberFormat";
export var getVotersByChannelChartOptions = function (_a) {
    var labels = _a.labels, numberFormatPolicy = _a.numberFormatPolicy;
    return (__assign(__assign({}, getPieChartNumberFormatOptions(numberFormatPolicy)), { labels: labels, plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        value: {
                            formatter: function (count) { return formatNumber(count, numberFormatPolicy); },
                        },
                        total: {
                            showAlways: true,
                            show: true,
                            formatter: function (_a) {
                                var globals = _a.globals;
                                return formatNumber(globals.seriesTotals.reduce(function (sum, count) { return sum + count; }, 0), numberFormatPolicy);
                            },
                        },
                    },
                },
            },
        } }));
};
